module.exports = __webpack_public_path__ + "img/deadlines.53e7d797.png";